export default "<h3>February 8, 2019</h3>\r\n<p>Update 0.74 updates the game's privacy policy.</p>";